import { memo, useCallback, useRef, useState } from "react";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { PlayFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlayFilled";
import { GalleryVideoObject } from "../../Galleries/utils/utils";
import styles from "./ZoomModalVideo.module.scss";

type ZoomModalVideoProps = {
  video: GalleryVideoObject;
  index: number;
  total: number;
  scrollToIndex: (index: number) => void;
};

export const ZoomModalVideo = memo(function GalleryVideo({
  video,
  index,
  total,
  scrollToIndex,
}: ZoomModalVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = useCallback(() => {
    scrollToIndex(index);
    videoRef.current?.play();
    setIsPlaying(true);
  }, []);

  return (
    <div className={styles.videoWrapper}>
      <video
        ref={videoRef}
        className={styles.video}
        controls={isPlaying}
        poster={video.posterUrl}
        src={video.videoUrl}
        aria-label={`Product video ${index + 1} of ${total}, ${video.title}`}
        data-testid={`gallery:zoom:modal:video-${index}`}
        onClick={() => scrollToIndex(index)}
      />
      {!isPlaying && (
        <>
          <button
            aria-label={`Play video ${index + 1} of ${total}, ${video.title}`}
            data-testid={`gallery:zoom:modal:video-play-button-${index}`}
            className={styles.videoPlayButton}
            onClick={handlePlay}
          ></button>
          <IconButton
            icon={PlayFilled}
            aria-label={`Play video ${index + 1} of ${total}, ${video.title}`}
            data-testid={`gallery:zoom:modal:video-play-icon-${index}`}
            className={styles.playButton}
            onClick={handlePlay}
            background="tonal"
            variant="inverted"
          />
        </>
      )}
    </div>
  );
});
